export const TAGS = (t) => [
    { id: 'striking_distance', label: t('opportunities.tabs.striking_distance') },
    { id: 'keyword_clusters', label: t('opportunities.tabs.keyword_clusters') },
    { id: 'directories', label: t('opportunities.tabs.directories') },
    { id: 'evergreen', label: t('opportunities.tabs.evergreen') },
    { id: 'year', label: t('opportunities.tabs.year') },
];
